"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankAuthorised = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../../../shared/core");
var analytics_subjects_1 = require("../../../../../../analytics-subjects");
var copy_1 = require("../../../../../../copy");
var BankAuthorised = function (_a) {
    var _b;
    var value = _a.value, handler = _a.handler, error = _a.error;
    var _c = (0, core_1.useComponents)(), Checkbox = _c.Checkbox, Stack = _c.Stack, Disclosure = _c.Disclosure;
    var _d = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _d.copy, Copy = _d.Copy;
    return (react_1.default.createElement(Stack, { spaceBetween: 4 },
        react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.SETUP_DD_BANK_AUTH, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
            react_1.default.createElement(Checkbox, { id: "bankAuthorised", label: copy('setupDirectDebitBankLabel'), checked: value, onChange: handler, error: error })),
        react_1.default.createElement("div", null,
            react_1.default.createElement(Disclosure, { title: copy('setupDirectDebitBankHelpTitle') },
                react_1.default.createElement(Copy, { copyKey: "setupDirectDebitBankHelpBody" })))));
};
exports.BankAuthorised = BankAuthorised;
